// validationRules/step3Validation.js

// Регулярное выражение для украинских букв (включая апостроф и дефис)
const UKRAINIAN_LETTERS_REGEX = /^[а-щьюяґєіїА-ЩЬЮЯҐЄІІЇ\'\-\.\s]+$/;

export const validateStep3 = (formData, isEdit) => {
  const errors = {};

  // Проверка желаемой даты поступления
  if (formData.preferences?.desiredDate) {
    const desiredDate = new Date(formData.preferences?.desiredDate);
    desiredDate.setHours(23,59,59);
    const today = new Date();
    
    // Дата поступления не может быть в прошлом
    if ( !isEdit && (desiredDate < today) ) {
      errors.desiredDate = 'Бажана дата вступу не може бути у минулому';
    }
  }

  // Валидация типов мест (нельзя выбрать оба противоречащих варианта)
  if (formData.preferences?.withoutBed && formData.preferences?.notWithoutBed) {
    // Додаємо помилку тільки до одного поля
    errors.withoutBed = 'Не можна обрати обидва варіанти "Тільки короткотривале" та "Тільки повного дня"';
    // Не додаємо errors.notWithoutBed
  }

  // Если выбрана специализация по состоянию здоровья
  if (formData.preferences?.dissabilities) {
    
    // Проверка типа заболевания
    if (!formData.preferences?.diseaseType?.trim()) {
      errors.diseaseType = 'Вид захворювання обовʼязковий для заповнення';
    }

    // Проверка документа о заболевании
    if (formData.preferences.diseaseDocument) {
      const docErrors = validateDiseaseDocument(formData.preferences?.diseaseDocument, formData.child.birthDate);
      Object.assign(errors, docErrors);
    }

    if(formData.preferences.diseaseType && formData.preferences.inclusiveGroup && !(["58fdc4708e78266a9d926b65","58fdc47d8e78266a9d926b66","58fdc48f8e78266a9d926b67","58fdc49c8e78266a9d926b68","58fdc4a98e78266a9d926b69","58fdc4b48e78266a9d926b6a","593009177ed0bdb13cc331c3","58fdc4618e78266a9d926b64"].includes(formData.preferences.diseaseType))){
      //errors.diseaseType = 'Місця інклюзивного типу не передбачені для даного типу захворювання.'
      //errors.inclusiveGroup = 'Місця інклюзивного типу не передбачені для обраного типу захворювання.';
    }
  }

  return errors;
};

// Валидация документа о заболевании
export const validateDiseaseDocument = (diseaseDocument, childBirthDate) => {
  const errors = {};

  // Проверка типа документа
  if (!diseaseDocument.type?.trim()) {
    errors.diseaseDocumentType = 'Тип документа обовʼязковий для заповнення';
  }

  // Проверка номера документа
  if (!diseaseDocument.number?.trim()) {
    errors.diseaseDocumentNumber = 'Номер документа обовʼязковий для заповнення';
  }

  // Проверка ФИО (кому выдано) на украинские буквы
  if (diseaseDocument.issuedTo) {
    if (!UKRAINIAN_LETTERS_REGEX.test(diseaseDocument.issuedTo)) {
      errors.diseaseDocumentIssuedTo = 'ПІБ має містити тільки українські літери, апостроф або дефіс';
    }
  } else {
    errors.diseaseDocumentIssuedTo = 'Поле "Кому видано" обовʼязкове для заповнення';
  }

  // Проверка даты выдачи документа
  if (diseaseDocument.issueDate) {
    const issueDate = new Date(diseaseDocument.issueDate);
    const today = new Date();
    
    // Документ не может быть выдан в будущем
    if (issueDate > today) {
      errors.diseaseDocumentDate = 'Дата видачі документа не може бути у майбутньому';
    }

    // Документ не может быть старше возраста ребенка
    if (childBirthDate) {
      const birthDate = new Date(childBirthDate);
      
      if (issueDate < birthDate) {
        errors.diseaseDocumentDate = 'Дата видачі документа не може бути раніше дати народження дитини';
      }
    }
  } else {
    errors.diseaseDocumentDate = 'Дата видачі документа обовʼязкова для заповнення';
  }

  return errors;
};

// Дополнительные утилиты для валидации в реальном времени
export const validateUkrainianText = (value, fieldName) => {
  if (!value) return null;
  
  if (!UKRAINIAN_LETTERS_REGEX.test(value)) {
    switch (fieldName) {
      case 'issuedTo':
        return 'ПІБ має містити тільки українські літери, апостроф або дефіс';
      default:
        return 'Поле має містити тільки українські літери, апостроф або дефіс';
    }
  }
  
  return null;
};

export const validateDocumentDate = (issueDate, childBirthDate) => {
  if (!issueDate) return null;
  
  const docDate = new Date(issueDate);
  const today = new Date();
  
  // Документ не может быть выдан в будущем
  if (docDate > today) {
    return 'Дата видачі документа не може бути у майбутньому';
  }

  // Документ не может быть старше возраста ребенка
  if (childBirthDate) {
    const birthDate = new Date(childBirthDate);
    
    if (docDate < birthDate) {
      return 'Дата видачі документа не може бути раніше дати народження дитини';
    }
  }
  
  return null;
};

export const validateDesiredDate = (date) => {
  if (!date) return null;
  
  const desiredDate = new Date(date);
  const today = new Date();
  
  // Дата поступления не может быть в прошлом
  if (desiredDate < today) {
    return 'Бажана дата вступу не може бути у минулому';
  }
  
  return null;
};

// Валидация обязательных полей при включенной специализации
export const validateSpecializationRequired = (value, fieldName) => {
  if (!value?.trim()) {
    switch (fieldName) {
      case 'diseaseType':
        return 'Вид захворювання обовʼязковий для заповнення';
      case 'documentType':
        return 'Тип документа обовʼязковий для заповнення';
      case 'documentNumber':
        return 'Номер документа обовʼязковий для заповнення';
      case 'issuedTo':
        return 'Поле "Кому видано" обовʼязкове для заповнення';
      default:
        return 'Поле обовʼязкове для заповнення';
    }
  }
  return null;
};

// Валидация файлов
export const validateFiles = (files) => {
  if (!files || files.length === 0) {
    return 'Необхідно завантажити мінімум один файл документа';
  }
  return null;
};